import * as z from "zod";
import { definitionInputSchema, draftResultSchema } from "./common";

/**
 * Saves the editor's working copy. A draft with errors is saved and its
 * diagnostics returned; one that isn't an automation at all is rejected. A draft
 * changed since `draftRevision` (another tab or person saved) is a conflict.
 */
export const saveDraft = {
  name: "saveDraft" as const,
  input: z.object({
    id: z.string(),
    draft: definitionInputSchema,
    /** The draftRevision the editor loaded or last saved. */
    draftRevision: z.string(),
  }),
  output: draftResultSchema,
};
